import React from 'react'
import _ from 'lodash'

import * as CreditsAndLimitsConstants from './../helpers/constants'

const ACRSection = ({
  client,
  userData,
  getUserInfo
}) => {

  if (userData.user_role !== 'owner')
    return null

  const acrSection = CreditsAndLimitsConstants.CREDITS_LIMITS_TAB[client].ACR_SECTION

  return (
    <div className="credits-limits-section">
      <h5 className='text-center'>ACR Settings</h5>
      <div className='d-flex justify-content-between flex-column gap-2'>
        {
          acrSection.map((opts, idx) => {
            const accessorValue = _.get(userData, opts.accessorKey)
            return (
              <div
                key={idx}
                className='d-flex justify-content-between'
              >
                <p className='m-0'>{opts.label}</p>
                {
                  opts.formatter({
                    client,
                    value: accessorValue,
                    userData,
                    getUserInfo
                  })
                }
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default ACRSection